export class ListEntityResourcePermissionError extends Error {
    
}